// extracted by mini-css-extract-plugin
export default {"TextArea":"CreateOrUpdateConfiguration_TextArea__qInRi"};